import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLang } from '../hooks/useLang';

const Carrieres = () => {
  const { t } = useTranslation();
  const { routes } = useLang();
  const profiles = t('careers.profiles', { returnObjects: true });

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-grow pt-32 pb-20 px-8 lg:px-16">
        <div className="max-w-[1200px] mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-wide mb-16">{t('careers.title')}</h1>

          <div className="max-w-[800px]">
            <h2 className="text-2xl font-light mb-8">{t('careers.subtitle')}</h2>
            <p className="text-lg font-light text-gray-700 mb-8 leading-relaxed">{t('careers.intro')}</p>
            <p className="text-base font-light text-gray-600 mb-12 leading-relaxed">{t('careers.instruction')}</p>

            <div className="bg-[#f5f2ed] p-8 mb-12">
              <p className="text-base font-light mb-4">
                <span className="font-medium">{t('careers.email')}</span>{' '}
                <a href="mailto:candidatures@smarch.fr" data-testid="careers-email-link" className="text-[#d94e47] hover:underline">candidatures@smarch.fr</a>
              </p>
              <p className="text-base font-light">
                <span className="font-medium">{t('careers.subject')}</span> {t('careers.subjectValue')}
              </p>
            </div>

            <div className="border-t border-gray-200 pt-12">
              <h3 className="text-xl font-light mb-6">{t('careers.profilesTitle')}</h3>
              <ul className="space-y-3 text-base font-light text-gray-600">
                {Array.isArray(profiles) && profiles.map((p, i) => <li key={i}>• {p}</li>)}
              </ul>
            </div>

            <div className="mt-16">
              <Link to={routes.contact}
                className="inline-block px-8 py-4 bg-[#d94e47] text-white font-light hover:bg-opacity-90 transition-all duration-300">
                {t('careers.contactUs')}
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Carrieres;
